// Staging
// export const baseAPI = "https://api-v3-uat.career.support";
// Production
export const baseAPI = "https://api-v3.career.support";
